import { c as _c } from "react/compiler-runtime";
import { ComboboxButton, ComboboxOption, ComboboxOptions, Field } from '@headlessui/react';
import { ArrowButton, CloseButton, ComboboxSinge, FieldErrorAndDescription, FieldLabel, FormSelectDataType, FormSelectIdType, FormSelectInput, FormSelectProps, ListOptions, getSelectedData, getVirtualizedData, useFilteredData } from '@systemeio/ui';
import { useEffect, useMemo, useState } from 'react';
import { twMerge } from 'tailwind-merge';
interface FormSelectWithCreateProps<T extends FormSelectIdType> extends FormSelectProps<T> {
  createData: {
    getCustomCaption: (value: string) => string;
    onCreate: (data: string) => Promise<void>;
  };
}
const CREATE_DATA_KEY = '__create-data-key';
export function FormSelectWithCreate(t0) {
  const $ = _c(85);
  let arrowButtonClassName;
  let className;
  let closeButtonClassName;
  let containerClassName;
  let createData;
  let data;
  let dataTest;
  let description;
  let disabled;
  let error;
  let fieldClassName;
  let inputRef;
  let inputWrapperClassName;
  let isPreFetching;
  let label;
  let labelClassName;
  let onChange;
  let onClose;
  let onOpen;
  let optionsProps;
  let placeholder;
  let required;
  let staticData;
  let value;
  let withoutCloseIcon;
  let wrapperProps;
  if ($[0] !== t0) {
    const {
      label: t1,
      data: t2,
      staticData: t3,
      onChange: t4,
      labelClassName: t5,
      value: t6,
      isPreFetching: t7,
      placeholder: t8,
      error: t9,
      required: t10,
      description: t11,
      className: t12,
      containerClassName: t13,
      closeButtonClassName: t14,
      arrowButtonClassName: t15,
      fieldClassName: t16,
      disabled: t17,
      withoutCloseIcon: t18,
      onOpen: t19,
      onClose: t20,
      dataTest: t21,
      wrapperProps: t22,
      loaderClassName,
      loaderWrapperClassName,
      inputWrapperClassName: t23,
      inputRef: t24,
      createData: t25,
      ...t26
    } = t0;
    label = t1;
    data = t2;
    staticData = t3;
    onChange = t4;
    labelClassName = t5;
    value = t6;
    isPreFetching = t7;
    placeholder = t8;
    error = t9;
    required = t10;
    description = t11;
    className = t12;
    containerClassName = t13;
    closeButtonClassName = t14;
    arrowButtonClassName = t15;
    fieldClassName = t16;
    disabled = t17;
    withoutCloseIcon = t18;
    onOpen = t19;
    onClose = t20;
    dataTest = t21;
    wrapperProps = t22;
    inputWrapperClassName = t23;
    inputRef = t24;
    createData = t25;
    optionsProps = t26;
    $[0] = t0;
    $[1] = arrowButtonClassName;
    $[2] = className;
    $[3] = closeButtonClassName;
    $[4] = containerClassName;
    $[5] = createData;
    $[6] = data;
    $[7] = dataTest;
    $[8] = description;
    $[9] = disabled;
    $[10] = error;
    $[11] = fieldClassName;
    $[12] = inputRef;
    $[13] = inputWrapperClassName;
    $[14] = isPreFetching;
    $[15] = label;
    $[16] = labelClassName;
    $[17] = onChange;
    $[18] = onClose;
    $[19] = onOpen;
    $[20] = optionsProps;
    $[21] = placeholder;
    $[22] = required;
    $[23] = staticData;
    $[24] = value;
    $[25] = withoutCloseIcon;
    $[26] = wrapperProps;
  } else {
    arrowButtonClassName = $[1];
    className = $[2];
    closeButtonClassName = $[3];
    containerClassName = $[4];
    createData = $[5];
    data = $[6];
    dataTest = $[7];
    description = $[8];
    disabled = $[9];
    error = $[10];
    fieldClassName = $[11];
    inputRef = $[12];
    inputWrapperClassName = $[13];
    isPreFetching = $[14];
    label = $[15];
    labelClassName = $[16];
    onChange = $[17];
    onClose = $[18];
    onOpen = $[19];
    optionsProps = $[20];
    placeholder = $[21];
    required = $[22];
    staticData = $[23];
    value = $[24];
    withoutCloseIcon = $[25];
    wrapperProps = $[26];
  }
  const [opened, setOpened] = useState(false);
  let t1;
  if ($[27] !== onOpen || $[28] !== opened) {
    t1 = () => {
      if (opened && onOpen) {
        onOpen();
        setOpened(false);
      }
    };
    $[27] = onOpen;
    $[28] = opened;
    $[29] = t1;
  } else {
    t1 = $[29];
  }
  let t2;
  if ($[30] !== opened) {
    t2 = [opened];
    $[30] = opened;
    $[31] = t2;
  } else {
    t2 = $[31];
  }
  useEffect(t1, t2);
  let t3;
  if ($[32] !== data || $[33] !== staticData || $[34] !== value) {
    t3 = getSelectedData(value, data ?? staticData) ?? null;
    $[32] = data;
    $[33] = staticData;
    $[34] = value;
    $[35] = t3;
  } else {
    t3 = $[35];
  }
  const selectedData = t3;
  const {
    filteredData,
    query,
    setQuery
  } = useFilteredData(data);
  const hasValue = value !== undefined;
  const noData = !data && !staticData;
  const onlyValue = hasValue && noData;
  const isDisabled = disabled || isPreFetching || onlyValue;
  let t4;
  if ($[36] !== createData || $[37] !== filteredData || $[38] !== query) {
    bb0: {
      const virtualData = getVirtualizedData(filteredData);
      if (!virtualData) {
        t4 = undefined;
        break bb0;
      }
      const hasCreatDataItem = virtualData.options.some(_temp);
      if (!hasCreatDataItem && !!query) {
        virtualData.options.unshift({
          id: CREATE_DATA_KEY,
          caption: query,
          customCaption: createData.getCustomCaption(query)
        });
      }
      t4 = virtualData;
    }
    $[36] = createData;
    $[37] = filteredData;
    $[38] = query;
    $[39] = t4;
  } else {
    t4 = $[39];
  }
  const virtual = t4;
  const showCloseButton = hasValue && !withoutCloseIcon && !isDisabled;
  let t5;
  if ($[40] !== containerClassName) {
    t5 = twMerge("relative flex flex-col gap-1", containerClassName);
    $[40] = containerClassName;
    $[41] = t5;
  } else {
    t5 = $[41];
  }
  let t6;
  if ($[42] !== createData || $[43] !== onChange || $[44] !== query) {
    t6 = async data_0 => {
      onChange(data_0);
      if (data_0 === CREATE_DATA_KEY) {
        await createData.onCreate(query);
      }
    };
    $[42] = createData;
    $[43] = onChange;
    $[44] = query;
    $[45] = t6;
  } else {
    t6 = $[45];
  }
  let t7;
  if ($[46] !== onClose || $[47] !== setQuery) {
    t7 = () => {
      setQuery("");
      onClose?.();
    };
    $[46] = onClose;
    $[47] = setQuery;
    $[48] = t7;
  } else {
    t7 = $[48];
  }
  let t8;
  if ($[49] !== arrowButtonClassName || $[50] !== className || $[51] !== closeButtonClassName || $[52] !== dataTest || $[53] !== error || $[54] !== fieldClassName || $[55] !== filteredData || $[56] !== inputRef || $[57] !== inputWrapperClassName || $[58] !== isDisabled || $[59] !== isPreFetching || $[60] !== label || $[61] !== labelClassName || $[62] !== onChange || $[63] !== optionsProps || $[64] !== placeholder || $[65] !== required || $[66] !== selectedData?.caption || $[67] !== setQuery || $[68] !== showCloseButton || $[69] !== wrapperProps) {
    t8 = open => <><Field className={twMerge("relative flex flex-col gap-1", fieldClassName)}><FieldLabel wrapperAs="label" wrapperProps={wrapperProps} label={label} required={required} labelClassName={twMerge("text-sm font-medium", labelClassName)} /><ComboboxButton as="button" className={twMerge("relative", inputWrapperClassName)}><FormSelectInput dataTest={dataTest} inputRef={inputRef} isDisabled={isDisabled} hasError={!!error} open={open} className={className} placeholder={placeholder} selectedCaption={selectedData?.caption ?? ""} isPreFetching={isPreFetching} onFocus={() => setOpened(true)} onChange={value_0 => {
            setOpened(true);
            setQuery(value_0);
          }} /><ArrowButton isDisabled={isDisabled} arrowButtonClassName={twMerge("absolute inset-y-0 right-4 h-[46px] sm:h-[42px]", arrowButtonClassName)} open={open} /></ComboboxButton>{showCloseButton && <CloseButton isDisabled={isDisabled} closeButtonClassName={twMerge("absolute bottom-0 right-10 h-[46px] sm:h-[42px]", closeButtonClassName)} onClick={() => onChange(undefined)} />}</Field><ListOptions asOptions={ComboboxOptions} asOption={ComboboxOption} data={filteredData} {...optionsProps} /></>;
    $[49] = arrowButtonClassName;
    $[50] = className;
    $[51] = closeButtonClassName;
    $[52] = dataTest;
    $[53] = error;
    $[54] = fieldClassName;
    $[55] = filteredData;
    $[56] = inputRef;
    $[57] = inputWrapperClassName;
    $[58] = isDisabled;
    $[59] = isPreFetching;
    $[60] = label;
    $[61] = labelClassName;
    $[62] = onChange;
    $[63] = optionsProps;
    $[64] = placeholder;
    $[65] = required;
    $[66] = selectedData?.caption;
    $[67] = setQuery;
    $[68] = showCloseButton;
    $[69] = wrapperProps;
    $[70] = t8;
  } else {
    t8 = $[70];
  }
  let t9;
  if ($[71] !== isDisabled || $[72] !== selectedData || $[73] !== t6 || $[74] !== t7 || $[75] !== t8 || $[76] !== virtual) {
    t9 = <ComboboxSinge selectedData={selectedData} virtual={virtual} onChange={t6} disabled={isDisabled} onClose={t7}>{t8}</ComboboxSinge>;
    $[71] = isDisabled;
    $[72] = selectedData;
    $[73] = t6;
    $[74] = t7;
    $[75] = t8;
    $[76] = virtual;
    $[77] = t9;
  } else {
    t9 = $[77];
  }
  let t10;
  if ($[78] !== description || $[79] !== error) {
    t10 = <FieldErrorAndDescription error={error} description={description} />;
    $[78] = description;
    $[79] = error;
    $[80] = t10;
  } else {
    t10 = $[80];
  }
  let t11;
  if ($[81] !== t10 || $[82] !== t5 || $[83] !== t9) {
    t11 = <div className={t5}>{t9}{t10}</div>;
    $[81] = t10;
    $[82] = t5;
    $[83] = t9;
    $[84] = t11;
  } else {
    t11 = $[84];
  }
  return t11;
}
function _temp(el) {
  return el.id === CREATE_DATA_KEY;
}